<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form
            v-if="isSearch"
            :model="queryForm"
            ref="form"
            label-width="80px"
            :inline="true"
            size="small"
            class="query-form"
            @submit.native.prevent
        >
            <el-form-item label="登录账号">
                <el-input v-model="queryForm.userName" placeholder="请填写登录账号" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="queryForm.userMobile" placeholder="请填写手机号码" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="用户昵称">
                <el-input v-model="queryForm.userNickname" placeholder="请填写用户昵称" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名">
                <el-input v-model="queryForm.userRealname" placeholder="请填写真实姓名" style="width: 175px"></el-input>
            </el-form-item>
            <el-form-item label="货币类型">
                <el-select placeholder="请选择货币类型" clearable v-model="queryForm.currencyType" style="width: 175px">
                    <el-option v-for="item in currencyTypeList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="记录状态">
                <el-select placeholder="请选择记录状态" clearable v-model="queryForm.recordStatus" style="width: 180px">
                    <el-option v-for="status in recordStatusList" :key="status.key" :label="status.value" :value="status.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作时间">
                <el-date-picker
                    style="width: 180px"
                    v-model="timeRange"
                    type="datetimerange"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="-"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item style="margin-left: 80px">
                <el-button size="small" type="primary" icon="el-icon-search" @click="searchRecordList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group" style="display: flex">
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteShopMoneyRecord(null)"
                        >删除</el-button
                    >
                </div>

                <div class="icon-group">
                    <span title="搜索" class="icon-box" @click="search">
                        <Icon color="#606266">
                            <Search />
                        </Icon>
                    </span>
                    <span title="导出数据" class="icon-box" @click="exportShopMoneyRecordList">
                        <Icon color="#606266">
                            <ArrowDownload24Regular />
                        </Icon>
                    </span>
                    <span class="icon-box" @click="refreshShopMoneyRecordList">
                        <Icon color="#606266">
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="shopMoneyRecordList"
                width="100%"
                row-key="id"
                size="small"
                height="100%"
                @selection-change="handleSelectionChange"
                :default-expand-all="true"
            >
                <el-table-column align="center" type="selection" width="50px"> </el-table-column>
                <el-table-column align="left" label="用户" width="150px">
                    <template slot-scope="scope">
                        <div v-if="scope.row.user">
                            <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
							<div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                            <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                            <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>

                        </div>
                        <div v-else>--</div>
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="withdraw.serviceFee" label="手续费"> </el-table-column>
				<el-table-column :show-overflow-tooltip="true" align="center" prop="money" label="金额"> </el-table-column>
				<el-table-column :show-overflow-tooltip="true" align="center" prop="withdraw.actualMoney" label="实到"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="记录类型">
                    <template slot-scope="scope">
                        {{ getType(scope.row.recordType) }}
                    </template>
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" label="提现信息" width="200">
                    <template slot-scope="scope" v-if='scope.row.withdraw != null'>
                        <div style="text-align: left">
                            银行：{{ scope.row.withdraw.bankName }} <span v-if="scope.row.withdraw.bankCode">({{ scope.row.withdraw.bankCode }})</span>
                        </div>
                        <div style="text-align: left">姓名：{{ scope.row.withdraw.cardHolder }}</div>
                        <div style="text-align: left">卡号：{{ scope.row.withdraw.bankCard }}</div>
                    </template>
                    <template slot-scope="scope" v-else>
                        <div style="text-align: left">--</div>
                    </template>
                </el-table-column>

                <el-table-column :show-overflow-tooltip="true" align="center" label="货币类型">
                    <template slot-scope="scope">
                        {{ getCurrencyType(scope.row.currencyType) }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" label="记录状态">
                    <template slot-scope="scope">
                        {{ getRecordStatus(scope.row.recordStatus) }}
                    </template>
                </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="sourceType" label="源类型"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="relatedNo" label="相关编号"> </el-table-column>
                <el-table-column :show-overflow-tooltip="true" align="center" prop="createTime" label="创建时间"> </el-table-column>
                <el-table-column align="center" label="操作" width="200">
                    <template slot-scope="scop">
                        <div class="operation">
                            <el-button type="primary" round size="mini" v-show="scop.row.recordStatus == 5" @click="examineButton(scop.row)"
                                >待审核</el-button
                            >
                            <!-- <div @click="withdrawal(scop.row.id)" v-if="scop.row.transfer == 0">
                                <span class="operation-label">提现代付</span>
                            </div> -->
                            <div v-if="scop.row.transfer == 1">
                                <span class="operation-label">已代付</span>
                            </div>
                            <div v-if="scop.row.transfer == 2">
                                <span class="operation-label">手动付款</span>
                            </div>
                            <!-- <div @click="deleteShopMoneyRecord(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div> -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>

            <!--审核功能-->
            <el-dialog title="资金提现审核" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
                <el-form ref="retreatForm" :rules="retreatRules" size="small" :model="retreatForm" label-width="100px">
                    <el-form-item label="是否同意：" prop="resource">
                        <el-radio-group v-model="retreatForm.resource">
                            <el-radio label="true">同意</el-radio>
                            <el-radio label="false">拒绝</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="拒绝原因：" v-if="retreatForm.resource == 'false'" prop="desc">
                        <el-input style="width: 100%" type="textarea" v-model="retreatForm.desc"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                  <el-button @click="handleClose">取 消</el-button>
                  <el-button type="primary" @click="retreatSuccess('retreatForm')">确 定</el-button>
                </span>
            </el-dialog>

<!--            <el-dialog title="审核" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">-->
<!--                <el-form ref="form" :inline="true" :model="examineObj" size="small" label-width="80px">-->
<!--                    -->
<!--                    <el-form-item label="失败原因">-->
<!--                        <el-input type="textarea" :rows="6" v-model="examineObj.recordDetail" disabled></el-input>-->
<!--                    </el-form-item>-->
<!--                </el-form>-->
<!--                <span slot="footer" class="dialog-footer">-->
<!--                    <el-button type="danger" @click="failButton">审核失败</el-button>-->
<!--                    <el-button type="success" @click="successButton">审核成功</el-button>-->
<!--                </span>-->
<!--            </el-dialog>-->
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, get, post, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopMoneyRecordList();
                this.getShopMoneyRecordList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopMoneyRecordList();
                this.getShopMoneyRecordList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            examineObj: {
                id: '',
                user: {
                    userMobile: null
                },
                bankName: '',
                money: 0,
                bankCard: '',
                cardHolder: '',
                recordDetail: '',
            },
            retreatForm:{
                resource:'',
                desc:''
            },
            auditId:'',
            retreatRules: {
                resource: [{ required: true, message: '请选择是否同意', trigger: 'change' }],
                desc: [{ required: true, message: '请填写拒绝原因', trigger: 'blur' }]
            },
            timeRange: [],
            queryForm: {
                recordStatus: null, //记录状态
                currencyType: null, //目标类型
                userName: null,
                startTime: null,
                endTime: null,
                userMobile: '',
                userNickname: '',
                userRealname: ''
            },
            recordStatusList: [], //明细状态
            recordTypeList: [], //明细类型：充值，消费，收入，提现
            currencyTypeList: [], //货币类型
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopMoneyRecordState: 'add',
            shopMoneyRecordStates: {
                add: '新建余额明细',
                check: '查看余额明细',
                edit: '修改余额明细'
            },

            multipleSelection: [],
            shopMoneyRecordList: [],
            shopMoneyRecord: {
                id: '', //ID
                userId: '', //所属用户
                money: '', //金额
                recordDetail: '', //记录详情
                recordType: '', //记录类型
                recordStatus: '', //记录状态
                targetId: '', //目标Id
                targetType: '' //目标类型
            },
            btnLoading: false,

            rules: {},
            dialogVisible: false,
        };
    },
    created() {
        this.getShopMoneyRecordList();
        this.getRecordTypeList();
        this.getRecordStatusList();
        this.getCurrencyTypeList();
    },
    methods: {
        handleClose() {
            this.dialogVisible = false;
            this.retreatForm.resource = ''
            this.retreatForm.desc = ''
        },
        examineButton(item) {
            this.dialogVisible = true;
            this.examineObj = item;
            this.auditId = item.id
            console.log(item);
        },

        retreatSuccess(formName){
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    //处理选择同意&拒绝
                    let status = 5
                    this.retreatForm.resource == 'true' ? status = 6 : status = 7
                    this.dialogVisible = false
                    get(`/mpp/moneyrecord/auditWithdraw`,{
                        id:this.auditId,
                        status:status,
                        refuseReason:this.retreatForm.desc,
                    }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getShopMoneyRecordList()
                        }
                    });
                }
            })
        },

        getCurrencyType(type) {
            for (const index in this.currencyTypeList) {
                if (this.currencyTypeList[index].key == type) {
                    return this.currencyTypeList[index].value;
                }
            }
        },

        getType(type) {
            for (const index in this.recordTypeList) {
                if (this.recordTypeList[index].key == type) {
                    return this.recordTypeList[index].value;
                }
            }
        },
        getRecordStatus(recordStatus) {
            for (const index in this.recordStatusList) {
                if (this.recordStatusList[index].key == recordStatus) {
                    return this.recordStatusList[index].value;
                }
            }
        },
        search() {
            this.isSearch = !this.isSearch;
        },
        resetShopMoneyRecordList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopMoneyRecordList = [];
        },
        resetDialog() {
            this.shopMoneyRecordState = 'add';
            this.showDialog = false;
            this.queryForm = {
                recordStatus: null, //记录状态
                currencyType: null, //目标类型
                userName: null,
                startTime: null,
                endTime: null,
                userMobile: '',
                userNickname: '',
                userRealname: ''
            };
            this.timeRange = [];
            this.getShopMoneyRecordList();
        },

        checkShopMoneyRecord(shopMoneyRecordId) {
            this.currentShopMoneyRecordId = shopMoneyRecordId;
            this.getShopMoneyRecordById();
            this.showDialog = true;
            this.shopMoneyRecordState = 'check';
        },
        editShopMoneyRecord(shopMoneyRecordId) {
            console.log('shopMoneyRecord', shopMoneyRecordId);
            if (shopMoneyRecordId) {
                this.currentShopMoneyRecordId = shopMoneyRecordId;
                this.shopMoneyRecord.id = shopMoneyRecordId;
                this.getShopMoneyRecordById();
            } else {
                this.shopMoneyRecord = { ...this.shopMoneyRecord, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopMoneyRecordState = 'edit';
        },
        deleteShopMoneyRecord(shopMoneyRecordId) {
            let ids = '';
            if (shopMoneyRecordId) {
                ids = shopMoneyRecordId;
            } else {
                ids = this.multipleSelection.map((shopMoneyRecord) => shopMoneyRecord.id).join(',');
            }
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/moneyrecord/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopMoneyRecordList();
                            this.getShopMoneyRecordList();
                        }
                    });
                })
                .catch(() => {});
        },
        refreshShopMoneyRecordList() {
            this.resetShopMoneyRecordList();
            this.getShopMoneyRecordList();
        },
        getShopMoneyRecordList() {
            this.loading = true;
            if (this.timeRange != null) {
                this.queryForm.startTime = this.timeRange[0];
                this.queryForm.endTime = this.timeRange[1];
            }
            // console.log(this.queryForm);
            get(`/mpp/moneyrecord/findWithdrawList`, { ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopMoneyRecordList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopMoneyRecordById() {
            get(`/mpp/moneyrecord/get`, { id: this.currentShopMoneyRecordId }).then((res) => {
                if (res.success) {
                    this.shopMoneyRecord = { ...this.shopMoneyRecord, ...res.shopMoneyRecord };
                }
            });
        },
        /**
         * 导出余额明细信息
         */
        exportShopMoneyRecordList() {
            exprotExcel(`/finance/moneyrecord/exportWithdraw`, { ...this.queryForm });
        },
        //记录类型
        /**
         * 获取记录类型列表
         * 
         * 从后端API获取资金记录类型的枚举列表，用于界面显示和数据处理
         */
        getRecordTypeList() {
            get(`/mpp/utils/getEnum`, { enumType: `money_record_type` }).then((res) => {
                if (res.success) {
                    this.recordTypeList = res.enumList;
                }
            });
        },
        //获取货币类型
        getCurrencyTypeList() {
            get(`/mpp/utils/getEnum`, { enumType: `currency_type` }).then((res) => {
                if (res.success) {
                    this.currencyTypeList = res.enumList;
                }
            });
        },
        //记录状态
        getRecordStatusList() {
            get(`/mpp/utils/getEnum`, { enumType: `money_record_status` }).then((res) => {
                if (res.success) {
                    this.recordStatusList = res.enumList;
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopMoneyRecordList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopMoneyRecordList();
        },
        withdrawal(id) {
            this.$confirm('确认提现代付吗, 是否继续?', '提现代付', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    // return;
                    get(`/transfer/transfer`, { recordId: id }).then((res) => {
                        if (res.success && res.code == 200) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.getShopMoneyRecordList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        searchRecordList() {
            this.getShopMoneyRecordList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
.moneyRecord-table-expand {
    font-size: 0;
    margin-top: -20px;
}
.moneyRecord-table-expand label {
    width: 90px;
    color: #99a9bf;
}
.moneyRecord-table-expand .el-form-item {
    margin-left: 4%;
    margin-bottom: -1%;
    width: 100%;
}
.sum {
    margin-left: 10px;
    display: flex;
    justify-content: center;
    font-size: 14px;
    color: #606266;
}
</style>
